import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row-top gap-04" }
const _hoisted_2 = {
  key: 0,
  style: {"margin-left":"-0.1rem"}
}

import { ref, computed } from 'vue';
import {apiDateString} from "@/api/apicommon";
import stylesJS from "@/assets/styles.js";
import styleJSON from "@/assets/style.json";
import { formatDoseToNaturalLanguage } from '@/functions/dosageUtils';
import { useAppUserStore } from '@/stores/appUser';



export default /*@__PURE__*/_defineComponent({
  __name: 'tLineItem',
  props: {
  content: {
    type: Object,
    required: true,
  },
  styles: {
    type: String,
    default: "",
  },
  index: {
    type: Number,
    required: true,
  },   
},
  emits: ['events'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore()
const emits = __emit;
const props = __props


const hover = ref(false)
const id = computed(() => {
  return props.content?.id || ""
})

const toolTipDate = computed(() => {
  const expr = props.content
  const isSap = expr.expressionType === "SubstanceAdministrationPrescription"
  if (isSap) {
    return apiDateString(expr.timelineStart)
  } else {
    return apiDateString(expr.entry.entryStart)
  }
})

const toolTipText = computed(() => {
  const expr = props.content
  const doseTiming = props.content.doseTiming
  const isSap = expr.expressionType === "SubstanceAdministrationPrescription"
  if (isSap && doseTiming?.conceptTimingType !== "Stop") {
    return doseTiming.closestExpression.matchedText
  } else {
    return expr.originalText
  }
})

const toolTipPoso = computed(() => {
  const dt = props.content.doseTiming
  if (!dt) return ''
  return formatDoseToNaturalLanguage({
      text: dt.originalPosologie,
      days: dt.days ? String(dt.days) : '',
      asNeeded: dt.asRequired,
    },
    locale.value)
})

const locale = computed(() => 
  appUserStore?.currentAppUserData?.preferences?.menuLanguageIso || 'fr'
)

const classList = computed(() => {
  let sShadow = 'shadow'
  if (hover.value) {sShadow = 'bigshadow'}

  return [sShadow]
})

const styleArr = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iBg = importOBJ.bg || "bg"
  let iSize = importOBJ.size || "m"

  // itemSize
  let itemSize = styleJSON.itemSize[iSize].slice(0, -3)
  itemSize = itemSize * 0.75

  // All-Defaults
  let ret = []

  // Item-Defaults
  ret = ret.concat(
    {"user-select" : "none"},
    {"position" : "relative"},
    {"height" : itemSize + "rem"},
    {"top" : (((-1) * itemSize * props.index) + 0.1) + "rem"},
    {"left" : props.content.x * 100 + "%"},
    {"width" : props.content.width * 100 + "%"},
    {"min-width" : "0.75rem"},
  )
  // Borders according to: start & end
  if (props.content.end === "rounded") {ret = ret.concat(
    {"border-top-right-radius" : "50px"},
    {"border-bottom-right-radius" : "50px"},
  )} else {ret = ret.concat(
    {"border-top-right-radius" : "0"},
    {"border-bottom-right-radius" : "0"},
  )}
  if (props.content.start === "rounded") {ret = ret.concat(
    {"border-top-left-radius" : "50px"},
    {"border-bottom-left-radius" : "50px"},
  )} else {ret = ret.concat(
    {"border-top-left-radius" : "0"},
    {"border-bottom-left-radius" : "0"},
  )}

    // Factor -> encodes degree of abnormality / intensity
    // 0% aN -> factor = 0
    // 100% aN -> factor = 1
    let factor = props.content.factor //"0.7"
    let stripes = props.content.stripes
    let mainColor = stylesJS.colorMerge("heatmap", iBg, factor)
    let stripeColor = stylesJS.colorMerge("heatmap", iBg, (factor/2))
    if (stripes) {
      ret = ret.concat(
        {"background" : `repeating-linear-gradient(to right, ${mainColor}, ${mainColor} 7px, ${stripeColor} 7px, ${stripeColor} 9px)`},
      )
    } else {
      ret = ret.concat(
        {"background-color" : mainColor},
      )        
    }
  return ret
})

function hoverOn() {
  hover.value = true   
}

function hoverOff() {
  hover.value = false
}

function clicked() {
  emits('events', 'clicked', id.value)
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_toolTip = _resolveComponent("toolTip")!

  return (__props.content.x > -1)
    ? (_openBlock(), _createBlock(_component_toolTip, { key: 0 }, {
        tooltip: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: toolTipDate.value,
            styles: "font-s main-m"
          }, null, 8, ["txt"]),
          _createElementVNode("div", _hoisted_1, [
            (__props.content.doseTiming?.conceptTimingType === 'Stop')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_svg_item, {
                    icon: "stop",
                    styles: "main-m size-s"
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_text_item, {
              txt: toolTipText.value,
              styles: "font-s"
            }, null, 8, ["txt"]),
            (toolTipPoso.value)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 1,
                  txt: toolTipPoso.value,
                  styles: "font-s",
                  style: {"max-width":"20rem"},
                  class: "linebreak"
                }, null, 8, ["txt"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(classList.value),
            style: _normalizeStyle(styleArr.value),
            onClick: clicked,
            onMouseover: hoverOn,
            onMouseleave: hoverOff
          }, null, 38)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})